var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _childrenChange, childrenChange_fn;
const formSelector = ".Apparatus-Blocks-Editor__block--form";
class ApparatusBlockEditor extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _childrenChange);
    new MutationObserver(() => __privateMethod(this, _childrenChange, childrenChange_fn).call(this)).observe(this, {
      childList: true
    });
  }
  connectedCallback() {
    __privateMethod(this, _childrenChange, childrenChange_fn).call(this);
  }
  get editing() {
    return this.hasAttribute("editing");
  }
  set editing(value) {
    if (!!value) {
      this.setAttribute("editing", "");
    } else {
      this.removeAttribute("editing");
    }
  }
}
_childrenChange = new WeakSet();
childrenChange_fn = function() {
  this.editing = !!this.querySelector(formSelector);
};
customElements.define("apparatus-block-editor", ApparatusBlockEditor);
class DetailsMenuElement extends HTMLElement {
  get preload() {
    return this.hasAttribute("preload");
  }
  set preload(value) {
    if (value) {
      this.setAttribute("preload", "");
    } else {
      this.removeAttribute("preload");
    }
  }
  get src() {
    return this.getAttribute("src") || "";
  }
  set src(value) {
    this.setAttribute("src", value);
  }
  connectedCallback() {
    if (!this.hasAttribute("role"))
      this.setAttribute("role", "menu");
    const details = this.parentElement;
    if (!details)
      return;
    const summary = details.querySelector("summary");
    if (summary) {
      summary.setAttribute("aria-haspopup", "menu");
      if (!summary.hasAttribute("role"))
        summary.setAttribute("role", "button");
    }
    const subscriptions = [
      fromEvent(details, "compositionstart", (e) => trackComposition$1(this, e)),
      fromEvent(details, "compositionend", (e) => trackComposition$1(this, e)),
      fromEvent(details, "click", (e) => shouldCommit(details, e)),
      fromEvent(details, "change", (e) => shouldCommit(details, e)),
      fromEvent(details, "keydown", (e) => keydown$1(details, this, e)),
      fromEvent(details, "toggle", () => loadFragment(details, this), { once: true }),
      fromEvent(details, "toggle", () => closeCurrentMenu(details)),
      this.preload ? fromEvent(details, "mouseover", () => loadFragment(details, this), { once: true }) : NullSubscription,
      ...focusOnOpen(details)
    ];
    states$1.set(this, { subscriptions, loaded: false, isComposing: false });
  }
  disconnectedCallback() {
    const state = states$1.get(this);
    if (!state)
      return;
    states$1.delete(this);
    for (const sub of state.subscriptions) {
      sub.unsubscribe();
    }
  }
}
const states$1 = /* @__PURE__ */ new WeakMap();
const NullSubscription = {
  unsubscribe() {
  }
};
function fromEvent(target, eventName, onNext, options = false) {
  target.addEventListener(eventName, onNext, options);
  return {
    unsubscribe: () => {
      target.removeEventListener(eventName, onNext, options);
    }
  };
}
function loadFragment(details, menu) {
  const src = menu.getAttribute("src");
  if (!src)
    return;
  const state = states$1.get(menu);
  if (!state)
    return;
  if (state.loaded)
    return;
  state.loaded = true;
  const loader = menu.querySelector("include-fragment");
  if (loader && !loader.hasAttribute("src")) {
    loader.addEventListener("loadend", () => autofocus(details));
    loader.setAttribute("src", src);
  }
}
function focusOnOpen(details) {
  let isMouse = false;
  const onmousedown = () => isMouse = true;
  const onkeydown = () => isMouse = false;
  const ontoggle = () => {
    if (!details.hasAttribute("open"))
      return;
    if (autofocus(details))
      return;
    if (!isMouse)
      focusFirstItem(details);
  };
  return [
    fromEvent(details, "mousedown", onmousedown),
    fromEvent(details, "keydown", onkeydown),
    fromEvent(details, "toggle", ontoggle)
  ];
}
function closeCurrentMenu(details) {
  if (!details.hasAttribute("open"))
    return;
  for (const menu of document.querySelectorAll("details[open] > details-menu")) {
    const opened = menu.closest("details");
    if (opened && opened !== details && !opened.contains(details)) {
      opened.removeAttribute("open");
    }
  }
}
function autofocus(details) {
  if (!details.hasAttribute("open"))
    return false;
  const input = details.querySelector("details-menu [autofocus]");
  if (input) {
    input.focus();
    return true;
  } else {
    return false;
  }
}
function focusFirstItem(details) {
  const selected = document.activeElement;
  if (selected && isMenuItem(selected) && details.contains(selected))
    return;
  const target = sibling(details, true);
  if (target)
    target.focus();
}
function sibling(details, next) {
  const options = Array.from(details.querySelectorAll('[role^="menuitem"]:not([hidden]):not([disabled])'));
  const selected = document.activeElement;
  const index = selected instanceof HTMLElement ? options.indexOf(selected) : -1;
  const found = next ? options[index + 1] : options[index - 1];
  const def = next ? options[0] : options[options.length - 1];
  return found || def;
}
const ctrlBindings$1 = navigator.userAgent.match(/Macintosh/);
function shouldCommit(details, event) {
  const target = event.target;
  if (!(target instanceof Element))
    return;
  if (target.closest("details") !== details)
    return;
  if (event.type === "click") {
    const menuitem = target.closest('[role="menuitem"], [role="menuitemradio"]');
    if (!menuitem)
      return;
    const input = menuitem.querySelector("input");
    if (menuitem.tagName === "LABEL" && target === input)
      return;
    const onlyCommitOnChangeEvent = menuitem.tagName === "LABEL" && input && !input.checked;
    if (!onlyCommitOnChangeEvent) {
      commit$1(menuitem, details);
    }
  } else if (event.type === "change") {
    const menuitem = target.closest('[role="menuitemradio"], [role="menuitemcheckbox"]');
    if (menuitem)
      commit$1(menuitem, details);
  }
}
function updateChecked(selected, details) {
  for (const el of details.querySelectorAll('[role="menuitemradio"], [role="menuitemcheckbox"]')) {
    const input = el.querySelector('input[type="radio"], input[type="checkbox"]');
    let checkState = (el === selected).toString();
    if (input instanceof HTMLInputElement) {
      checkState = input.indeterminate ? "mixed" : input.checked.toString();
    }
    el.setAttribute("aria-checked", checkState);
  }
}
function commit$1(selected, details) {
  if (selected.hasAttribute("disabled") || selected.getAttribute("aria-disabled") === "true")
    return;
  const menu = selected.closest("details-menu");
  if (!menu)
    return;
  const dispatched = menu.dispatchEvent(new CustomEvent("details-menu-select", {
    cancelable: true,
    detail: { relatedTarget: selected }
  }));
  if (!dispatched)
    return;
  updateLabel(selected, details);
  updateChecked(selected, details);
  if (selected.getAttribute("role") !== "menuitemcheckbox")
    close(details);
  menu.dispatchEvent(new CustomEvent("details-menu-selected", {
    detail: { relatedTarget: selected }
  }));
}
function keydown$1(details, menu, event) {
  if (!(event instanceof KeyboardEvent))
    return;
  if (details.querySelector("details[open]"))
    return;
  const state = states$1.get(menu);
  if (!state || state.isComposing)
    return;
  const isSummaryFocused = event.target instanceof Element && event.target.tagName === "SUMMARY";
  switch (event.key) {
    case "Escape":
      if (details.hasAttribute("open")) {
        close(details);
        event.preventDefault();
        event.stopPropagation();
      }
      break;
    case "ArrowDown":
      {
        if (isSummaryFocused && !details.hasAttribute("open")) {
          details.setAttribute("open", "");
        }
        const target = sibling(details, true);
        if (target)
          target.focus();
        event.preventDefault();
      }
      break;
    case "ArrowUp":
      {
        if (isSummaryFocused && !details.hasAttribute("open")) {
          details.setAttribute("open", "");
        }
        const target = sibling(details, false);
        if (target)
          target.focus();
        event.preventDefault();
      }
      break;
    case "n":
      {
        if (ctrlBindings$1 && event.ctrlKey) {
          const target = sibling(details, true);
          if (target)
            target.focus();
          event.preventDefault();
        }
      }
      break;
    case "p":
      {
        if (ctrlBindings$1 && event.ctrlKey) {
          const target = sibling(details, false);
          if (target)
            target.focus();
          event.preventDefault();
        }
      }
      break;
    case " ":
    case "Enter":
      {
        const selected = document.activeElement;
        if (selected instanceof HTMLElement && isMenuItem(selected) && selected.closest("details") === details) {
          event.preventDefault();
          event.stopPropagation();
          selected.click();
        }
      }
      break;
  }
}
function isMenuItem(el) {
  const role = el.getAttribute("role");
  return role === "menuitem" || role === "menuitemcheckbox" || role === "menuitemradio";
}
function close(details) {
  const wasOpen = details.hasAttribute("open");
  if (!wasOpen)
    return;
  details.removeAttribute("open");
  const summary = details.querySelector("summary");
  if (summary)
    summary.focus();
}
function updateLabel(item, details) {
  const button = details.querySelector("[data-menu-button]");
  if (!button)
    return;
  const text = labelText(item);
  if (text) {
    button.textContent = text;
  } else {
    const html = labelHTML(item);
    if (html)
      button.innerHTML = html;
  }
}
function labelText(el) {
  if (!el)
    return null;
  const textEl = el.hasAttribute("data-menu-button-text") ? el : el.querySelector("[data-menu-button-text]");
  if (!textEl)
    return null;
  return textEl.getAttribute("data-menu-button-text") || textEl.textContent;
}
function labelHTML(el) {
  if (!el)
    return null;
  const contentsEl = el.hasAttribute("data-menu-button-contents") ? el : el.querySelector("[data-menu-button-contents]");
  return contentsEl ? contentsEl.innerHTML : null;
}
function trackComposition$1(menu, event) {
  const state = states$1.get(menu);
  if (!state)
    return;
  state.isComposing = event.type === "compositionstart";
}
if (!window.customElements.get("details-menu")) {
  window.DetailsMenuElement = DetailsMenuElement;
  window.customElements.define("details-menu", DetailsMenuElement);
}
class FilterInputElement extends HTMLElement {
  constructor() {
    super();
    this.currentQuery = null;
    this.filter = null;
    this.debounceInputChange = debounce(() => filterResults(this, true));
    this.boundFilterResults = () => {
      filterResults(this, false);
    };
  }
  static get observedAttributes() {
    return ["aria-owns"];
  }
  attributeChangedCallback(name, oldValue) {
    if (oldValue && name === "aria-owns") {
      filterResults(this, false);
    }
  }
  connectedCallback() {
    const input = this.input;
    if (!input)
      return;
    input.setAttribute("autocomplete", "off");
    input.setAttribute("spellcheck", "false");
    input.addEventListener("focus", this.boundFilterResults);
    input.addEventListener("change", this.boundFilterResults);
    input.addEventListener("input", this.debounceInputChange);
  }
  disconnectedCallback() {
    const input = this.input;
    if (!input)
      return;
    input.removeEventListener("focus", this.boundFilterResults);
    input.removeEventListener("change", this.boundFilterResults);
    input.removeEventListener("input", this.debounceInputChange);
  }
  get input() {
    const input = this.querySelector("input");
    return input instanceof HTMLInputElement ? input : null;
  }
  reset() {
    const input = this.input;
    if (input) {
      input.value = "";
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}
async function filterResults(filterInput, checkCurrentQuery = false) {
  const input = filterInput.input;
  if (!input)
    return;
  const query2 = input.value.trim();
  const id = filterInput.getAttribute("aria-owns");
  if (!id)
    return;
  const container = document.getElementById(id);
  if (!container)
    return;
  const list = container.hasAttribute("data-filter-list") ? container : container.querySelector("[data-filter-list]");
  if (!list)
    return;
  filterInput.dispatchEvent(new CustomEvent("filter-input-start", {
    bubbles: true
  }));
  if (checkCurrentQuery && filterInput.currentQuery === query2)
    return;
  filterInput.currentQuery = query2;
  const filter = filterInput.filter || matchSubstring;
  const total = list.childElementCount;
  let count = 0;
  let hideNew = false;
  for (const item of Array.from(list.children)) {
    if (!(item instanceof HTMLElement))
      continue;
    const itemText = getText(item);
    const result = filter(item, itemText, query2);
    if (result.hideNew === true)
      hideNew = result.hideNew;
    item.hidden = !result.match;
    if (result.match)
      count++;
  }
  const newItem = container.querySelector("[data-filter-new-item]");
  const showCreateOption = !!newItem && query2.length > 0 && !hideNew;
  if (newItem instanceof HTMLElement) {
    newItem.hidden = !showCreateOption;
    if (showCreateOption)
      updateNewItem(newItem, query2);
  }
  toggleBlankslate(container, count > 0 || showCreateOption);
  filterInput.dispatchEvent(new CustomEvent("filter-input-updated", {
    bubbles: true,
    detail: {
      count,
      total
    }
  }));
}
function matchSubstring(_item, itemText, query2) {
  const match = itemText.toLowerCase().indexOf(query2.toLowerCase()) !== -1;
  return {
    match,
    hideNew: itemText === query2
  };
}
function getText(filterableItem) {
  const target = filterableItem.querySelector("[data-filter-item-text]") || filterableItem;
  return (target.textContent || "").trim();
}
function updateNewItem(newItem, query2) {
  const newItemText = newItem.querySelector("[data-filter-new-item-text]");
  if (newItemText)
    newItemText.textContent = query2;
  const newItemValue = newItem.querySelector("[data-filter-new-item-value]");
  if (newItemValue instanceof HTMLInputElement || newItemValue instanceof HTMLButtonElement) {
    newItemValue.value = query2;
  }
}
function toggleBlankslate(container, force) {
  const emptyState = container.querySelector("[data-filter-empty-state]");
  if (emptyState instanceof HTMLElement)
    emptyState.hidden = force;
}
function debounce(callback) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      clearTimeout(timeout);
      callback();
    }, 300);
  };
}
if (!window.customElements.get("filter-input")) {
  window.FilterInputElement = FilterInputElement;
  window.customElements.define("filter-input", FilterInputElement);
}
var __classPrivateFieldGet$3 = globalThis && globalThis.__classPrivateFieldGet || function(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet$2 = globalThis && globalThis.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _IncludeFragmentElement_instances, _IncludeFragmentElement_busy, _IncludeFragmentElement_observer, _IncludeFragmentElement_handleData, _IncludeFragmentElement_getData, _IncludeFragmentElement_getStringOrErrorData, _IncludeFragmentElement_task, _IncludeFragmentElement_fetchDataWithEvents;
const privateData = /* @__PURE__ */ new WeakMap();
function isWildcard(accept) {
  return accept && !!accept.split(",").find((x) => x.match(/^\s*\*\/\*/));
}
let cspTrustedTypesPolicyPromise = null;
class IncludeFragmentElement extends HTMLElement {
  constructor() {
    super(...arguments);
    _IncludeFragmentElement_instances.add(this);
    _IncludeFragmentElement_busy.set(this, false);
    _IncludeFragmentElement_observer.set(this, new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const { target } = entry;
          __classPrivateFieldGet$3(this, _IncludeFragmentElement_observer, "f").unobserve(target);
          if (!(target instanceof IncludeFragmentElement))
            return;
          if (target.loading === "lazy") {
            __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_handleData).call(this);
          }
        }
      }
    }, {
      rootMargin: "0px 0px 256px 0px",
      threshold: 0.01
    }));
  }
  static define(tag = "include-fragment", registry = customElements) {
    registry.define(tag, this);
    return this;
  }
  static setCSPTrustedTypesPolicy(policy) {
    cspTrustedTypesPolicyPromise = policy === null ? policy : Promise.resolve(policy);
  }
  static get observedAttributes() {
    return ["src", "loading"];
  }
  get src() {
    const src = this.getAttribute("src");
    if (src) {
      const link = this.ownerDocument.createElement("a");
      link.href = src;
      return link.href;
    } else {
      return "";
    }
  }
  set src(val) {
    this.setAttribute("src", val);
  }
  get loading() {
    if (this.getAttribute("loading") === "lazy")
      return "lazy";
    return "eager";
  }
  set loading(value) {
    this.setAttribute("loading", value);
  }
  get accept() {
    return this.getAttribute("accept") || "";
  }
  set accept(val) {
    this.setAttribute("accept", val);
  }
  get data() {
    return __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_getStringOrErrorData).call(this);
  }
  attributeChangedCallback(attribute, oldVal) {
    if (attribute === "src") {
      if (this.isConnected && this.loading === "eager") {
        __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_handleData).call(this);
      }
    } else if (attribute === "loading") {
      if (this.isConnected && oldVal !== "eager" && this.loading === "eager") {
        __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_handleData).call(this);
      }
    }
  }
  connectedCallback() {
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" });
      const style = document.createElement("style");
      style.textContent = `:host {display: block;}`;
      this.shadowRoot.append(style, document.createElement("slot"));
    }
    if (this.src && this.loading === "eager") {
      __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_handleData).call(this);
    }
    if (this.loading === "lazy") {
      __classPrivateFieldGet$3(this, _IncludeFragmentElement_observer, "f").observe(this);
    }
  }
  request() {
    const src = this.src;
    if (!src) {
      throw new Error("missing src");
    }
    return new Request(src, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: this.accept || "text/html"
      }
    });
  }
  load() {
    return __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_getStringOrErrorData).call(this);
  }
  fetch(request) {
    return fetch(request);
  }
  refetch() {
    privateData.delete(this);
    __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_handleData).call(this);
  }
}
_IncludeFragmentElement_busy = /* @__PURE__ */ new WeakMap(), _IncludeFragmentElement_observer = /* @__PURE__ */ new WeakMap(), _IncludeFragmentElement_instances = /* @__PURE__ */ new WeakSet(), _IncludeFragmentElement_handleData = async function _IncludeFragmentElement_handleData2() {
  if (__classPrivateFieldGet$3(this, _IncludeFragmentElement_busy, "f"))
    return;
  __classPrivateFieldSet$2(this, _IncludeFragmentElement_busy, true, "f");
  __classPrivateFieldGet$3(this, _IncludeFragmentElement_observer, "f").unobserve(this);
  try {
    const data = await __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_getData).call(this);
    if (data instanceof Error) {
      throw data;
    }
    const dataTreatedAsString = data;
    const template = document.createElement("template");
    template.innerHTML = dataTreatedAsString;
    const fragment = document.importNode(template.content, true);
    const canceled = !this.dispatchEvent(new CustomEvent("include-fragment-replace", {
      cancelable: true,
      detail: { fragment }
    }));
    if (canceled) {
      __classPrivateFieldSet$2(this, _IncludeFragmentElement_busy, false, "f");
      return;
    }
    this.replaceWith(fragment);
    this.dispatchEvent(new CustomEvent("include-fragment-replaced"));
  } catch (_a) {
    this.classList.add("is-error");
  } finally {
    __classPrivateFieldSet$2(this, _IncludeFragmentElement_busy, false, "f");
  }
}, _IncludeFragmentElement_getData = async function _IncludeFragmentElement_getData2() {
  const src = this.src;
  const cachedData = privateData.get(this);
  if (cachedData && cachedData.src === src) {
    return cachedData.data;
  } else {
    let data;
    if (src) {
      data = __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_fetchDataWithEvents).call(this);
    } else {
      data = Promise.reject(new Error("missing src"));
    }
    privateData.set(this, { src, data });
    return data;
  }
}, _IncludeFragmentElement_getStringOrErrorData = async function _IncludeFragmentElement_getStringOrErrorData2() {
  const data = await __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_getData).call(this);
  if (data instanceof Error) {
    throw data;
  }
  return data.toString();
}, _IncludeFragmentElement_task = async function _IncludeFragmentElement_task2(eventsToDispatch) {
  await new Promise((resolve) => setTimeout(resolve, 0));
  for (const eventType of eventsToDispatch) {
    this.dispatchEvent(new Event(eventType));
  }
}, _IncludeFragmentElement_fetchDataWithEvents = async function _IncludeFragmentElement_fetchDataWithEvents2() {
  try {
    await __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_task).call(this, ["loadstart"]);
    const response = await this.fetch(this.request());
    if (response.status !== 200) {
      throw new Error(`Failed to load resource: the server responded with a status of ${response.status}`);
    }
    const ct = response.headers.get("Content-Type");
    if (!isWildcard(this.accept) && (!ct || !ct.includes(this.accept ? this.accept : "text/html"))) {
      throw new Error(`Failed to load resource: expected ${this.accept || "text/html"} but was ${ct}`);
    }
    const responseText = await response.text();
    let data = responseText;
    if (cspTrustedTypesPolicyPromise) {
      const cspTrustedTypesPolicy = await cspTrustedTypesPolicyPromise;
      data = cspTrustedTypesPolicy.createHTML(responseText, response);
    }
    __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_task).call(this, ["load", "loadend"]);
    return data;
  } catch (error) {
    __classPrivateFieldGet$3(this, _IncludeFragmentElement_instances, "m", _IncludeFragmentElement_task).call(this, ["error", "loadend"]);
    throw error;
  }
};
const root$1 = typeof globalThis !== "undefined" ? globalThis : window;
try {
  root$1.IncludeFragmentElement = IncludeFragmentElement.define();
} catch (e) {
  if (!(root$1.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) {
    throw e;
  }
}
var __classPrivateFieldGet$2 = globalThis && globalThis.__classPrivateFieldGet || function(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MarkdownHeaderButtonElement_instances, _MarkdownHeaderButtonElement_setLevelStyle;
const buttonSelectors = [
  "[data-md-button]",
  "md-header",
  "md-bold",
  "md-italic",
  "md-quote",
  "md-code",
  "md-link",
  "md-image",
  "md-unordered-list",
  "md-ordered-list",
  "md-task-list",
  "md-mention",
  "md-ref",
  "md-strikethrough"
];
function getButtons(toolbar) {
  const els = [];
  for (const button of toolbar.querySelectorAll(buttonSelectors.join(", "))) {
    if (button.hidden || button.offsetWidth <= 0 && button.offsetHeight <= 0)
      continue;
    if (button.closest("markdown-toolbar") === toolbar)
      els.push(button);
  }
  return els;
}
function keydown(fn) {
  return function(event) {
    if (event.key === " " || event.key === "Enter") {
      fn(event);
    }
  };
}
const styles = /* @__PURE__ */ new WeakMap();
const manualStyles = {
  "header-1": { prefix: "# " },
  "header-2": { prefix: "## " },
  "header-3": { prefix: "### " },
  "header-4": { prefix: "#### " },
  "header-5": { prefix: "##### " },
  "header-6": { prefix: "###### " },
  bold: { prefix: "**", suffix: "**", trimFirst: true },
  italic: { prefix: "_", suffix: "_", trimFirst: true },
  quote: { prefix: "> ", multiline: true, surroundWithNewlines: true },
  code: {
    prefix: "`",
    suffix: "`",
    blockPrefix: "```",
    blockSuffix: "```"
  },
  link: { prefix: "[", suffix: "](url)", replaceNext: "url", scanFor: "https?://" },
  image: { prefix: "![", suffix: "](url)", replaceNext: "url", scanFor: "https?://" },
  "unordered-list": {
    prefix: "- ",
    multiline: true,
    unorderedList: true
  },
  "ordered-list": {
    prefix: "1. ",
    multiline: true,
    orderedList: true
  },
  "task-list": { prefix: "- [ ] ", multiline: true, surroundWithNewlines: true },
  mention: { prefix: "@", prefixSpace: true },
  ref: { prefix: "#", prefixSpace: true },
  strikethrough: { prefix: "~~", suffix: "~~", trimFirst: true }
};
class MarkdownButtonElement extends HTMLElement {
  constructor() {
    super();
    const apply = (event) => {
      const style = styles.get(this);
      if (!style)
        return;
      event.preventDefault();
      applyStyle(this, style);
    };
    this.addEventListener("keydown", keydown(apply));
    this.addEventListener("click", apply);
  }
  connectedCallback() {
    if (!this.hasAttribute("role")) {
      this.setAttribute("role", "button");
    }
  }
  click() {
    const style = styles.get(this);
    if (!style)
      return;
    applyStyle(this, style);
  }
}
class MarkdownHeaderButtonElement extends MarkdownButtonElement {
  constructor() {
    super(...arguments);
    _MarkdownHeaderButtonElement_instances.add(this);
  }
  connectedCallback() {
    const level = parseInt(this.getAttribute("level") || "3", 10);
    __classPrivateFieldGet$2(this, _MarkdownHeaderButtonElement_instances, "m", _MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
  }
  static get observedAttributes() {
    return ["level"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== "level")
      return;
    const level = parseInt(newValue || "3", 10);
    __classPrivateFieldGet$2(this, _MarkdownHeaderButtonElement_instances, "m", _MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
  }
}
_MarkdownHeaderButtonElement_instances = /* @__PURE__ */ new WeakSet(), _MarkdownHeaderButtonElement_setLevelStyle = function _MarkdownHeaderButtonElement_setLevelStyle2(level) {
  if (level < 1 || level > 6) {
    return;
  }
  const prefix = `${"#".repeat(level)} `;
  styles.set(this, {
    prefix
  });
};
if (!window.customElements.get("md-header")) {
  window.MarkdownHeaderButtonElement = MarkdownHeaderButtonElement;
  window.customElements.define("md-header", MarkdownHeaderButtonElement);
}
class MarkdownBoldButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "**", suffix: "**", trimFirst: true });
  }
}
if (!window.customElements.get("md-bold")) {
  window.MarkdownBoldButtonElement = MarkdownBoldButtonElement;
  window.customElements.define("md-bold", MarkdownBoldButtonElement);
}
class MarkdownItalicButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "_", suffix: "_", trimFirst: true });
  }
}
if (!window.customElements.get("md-italic")) {
  window.MarkdownItalicButtonElement = MarkdownItalicButtonElement;
  window.customElements.define("md-italic", MarkdownItalicButtonElement);
}
class MarkdownQuoteButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "> ", multiline: true, surroundWithNewlines: true });
  }
}
if (!window.customElements.get("md-quote")) {
  window.MarkdownQuoteButtonElement = MarkdownQuoteButtonElement;
  window.customElements.define("md-quote", MarkdownQuoteButtonElement);
}
class MarkdownCodeButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "`", suffix: "`", blockPrefix: "```", blockSuffix: "```" });
  }
}
if (!window.customElements.get("md-code")) {
  window.MarkdownCodeButtonElement = MarkdownCodeButtonElement;
  window.customElements.define("md-code", MarkdownCodeButtonElement);
}
class MarkdownLinkButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "[", suffix: "](url)", replaceNext: "url", scanFor: "https?://" });
  }
}
if (!window.customElements.get("md-link")) {
  window.MarkdownLinkButtonElement = MarkdownLinkButtonElement;
  window.customElements.define("md-link", MarkdownLinkButtonElement);
}
class MarkdownImageButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "![", suffix: "](url)", replaceNext: "url", scanFor: "https?://" });
  }
}
if (!window.customElements.get("md-image")) {
  window.MarkdownImageButtonElement = MarkdownImageButtonElement;
  window.customElements.define("md-image", MarkdownImageButtonElement);
}
class MarkdownUnorderedListButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "- ", multiline: true, unorderedList: true });
  }
}
if (!window.customElements.get("md-unordered-list")) {
  window.MarkdownUnorderedListButtonElement = MarkdownUnorderedListButtonElement;
  window.customElements.define("md-unordered-list", MarkdownUnorderedListButtonElement);
}
class MarkdownOrderedListButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "1. ", multiline: true, orderedList: true });
  }
}
if (!window.customElements.get("md-ordered-list")) {
  window.MarkdownOrderedListButtonElement = MarkdownOrderedListButtonElement;
  window.customElements.define("md-ordered-list", MarkdownOrderedListButtonElement);
}
class MarkdownTaskListButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "- [ ] ", multiline: true, surroundWithNewlines: true });
  }
}
if (!window.customElements.get("md-task-list")) {
  window.MarkdownTaskListButtonElement = MarkdownTaskListButtonElement;
  window.customElements.define("md-task-list", MarkdownTaskListButtonElement);
}
class MarkdownMentionButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "@", prefixSpace: true });
  }
}
if (!window.customElements.get("md-mention")) {
  window.MarkdownMentionButtonElement = MarkdownMentionButtonElement;
  window.customElements.define("md-mention", MarkdownMentionButtonElement);
}
class MarkdownRefButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "#", prefixSpace: true });
  }
}
if (!window.customElements.get("md-ref")) {
  window.MarkdownRefButtonElement = MarkdownRefButtonElement;
  window.customElements.define("md-ref", MarkdownRefButtonElement);
}
class MarkdownStrikethroughButtonElement extends MarkdownButtonElement {
  connectedCallback() {
    styles.set(this, { prefix: "~~", suffix: "~~", trimFirst: true });
  }
}
if (!window.customElements.get("md-strikethrough")) {
  window.MarkdownStrikethroughButtonElement = MarkdownStrikethroughButtonElement;
  window.customElements.define("md-strikethrough", MarkdownStrikethroughButtonElement);
}
function applyFromToolbar(event) {
  const { target, currentTarget } = event;
  if (!(target instanceof HTMLElement))
    return;
  const mdButton = target.closest("[data-md-button]");
  if (!mdButton || mdButton.closest("markdown-toolbar") !== currentTarget)
    return;
  const mdButtonStyle = target.getAttribute("data-md-button");
  const style = manualStyles[mdButtonStyle];
  if (!style)
    return;
  event.preventDefault();
  applyStyle(target, style);
}
function setFocusManagement(toolbar) {
  toolbar.addEventListener("keydown", focusKeydown);
  toolbar.setAttribute("tabindex", "0");
  toolbar.addEventListener("focus", onToolbarFocus, { once: true });
}
function unsetFocusManagement(toolbar) {
  toolbar.removeEventListener("keydown", focusKeydown);
  toolbar.removeAttribute("tabindex");
  toolbar.removeEventListener("focus", onToolbarFocus);
}
class MarkdownToolbarElement extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute("role")) {
      this.setAttribute("role", "toolbar");
    }
    if (!this.hasAttribute("data-no-focus")) {
      setFocusManagement(this);
    }
    this.addEventListener("keydown", keydown(applyFromToolbar));
    this.addEventListener("click", applyFromToolbar);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== "data-no-focus")
      return;
    if (newValue === null) {
      setFocusManagement(this);
    } else {
      unsetFocusManagement(this);
    }
  }
  disconnectedCallback() {
    unsetFocusManagement(this);
  }
  get field() {
    const id = this.getAttribute("for");
    if (!id)
      return null;
    const root2 = "getRootNode" in this ? this.getRootNode() : document;
    let field;
    if (root2 instanceof Document || root2 instanceof ShadowRoot) {
      field = root2.getElementById(id);
    }
    return field instanceof HTMLTextAreaElement ? field : null;
  }
}
MarkdownToolbarElement.observedAttributes = ["data-no-focus"];
function onToolbarFocus({ target }) {
  if (!(target instanceof Element))
    return;
  target.removeAttribute("tabindex");
  let tabindex = "0";
  for (const button of getButtons(target)) {
    button.setAttribute("tabindex", tabindex);
    if (tabindex === "0") {
      button.focus();
      tabindex = "-1";
    }
  }
}
function focusKeydown(event) {
  const key = event.key;
  if (key !== "ArrowRight" && key !== "ArrowLeft" && key !== "Home" && key !== "End")
    return;
  const toolbar = event.currentTarget;
  if (!(toolbar instanceof HTMLElement))
    return;
  const buttons = getButtons(toolbar);
  const index = buttons.indexOf(event.target);
  const length = buttons.length;
  if (index === -1)
    return;
  let n = 0;
  if (key === "ArrowLeft")
    n = index - 1;
  if (key === "ArrowRight")
    n = index + 1;
  if (key === "End")
    n = length - 1;
  if (n < 0)
    n = length - 1;
  if (n > length - 1)
    n = 0;
  for (let i = 0; i < length; i += 1) {
    buttons[i].setAttribute("tabindex", i === n ? "0" : "-1");
  }
  event.preventDefault();
  buttons[n].focus();
}
if (!window.customElements.get("markdown-toolbar")) {
  window.MarkdownToolbarElement = MarkdownToolbarElement;
  window.customElements.define("markdown-toolbar", MarkdownToolbarElement);
}
function isMultipleLines(string) {
  return string.trim().split("\n").length > 1;
}
function repeat(string, n) {
  return Array(n + 1).join(string);
}
function wordSelectionStart(text, i) {
  let index = i;
  while (text[index] && text[index - 1] != null && !text[index - 1].match(/\s/)) {
    index--;
  }
  return index;
}
function wordSelectionEnd(text, i, multiline) {
  let index = i;
  const breakpoint = multiline ? /\n/ : /\s/;
  while (text[index] && !text[index].match(breakpoint)) {
    index++;
  }
  return index;
}
let canInsertText = null;
function insertText(textarea, { text, selectionStart, selectionEnd }) {
  const originalSelectionStart = textarea.selectionStart;
  const before = textarea.value.slice(0, originalSelectionStart);
  const after = textarea.value.slice(textarea.selectionEnd);
  if (canInsertText === null || canInsertText === true) {
    textarea.contentEditable = "true";
    try {
      canInsertText = document.execCommand("insertText", false, text);
    } catch (error) {
      canInsertText = false;
    }
    textarea.contentEditable = "false";
  }
  if (canInsertText && !textarea.value.slice(0, textarea.selectionStart).endsWith(text)) {
    canInsertText = false;
  }
  if (!canInsertText) {
    try {
      document.execCommand("ms-beginUndoUnit");
    } catch (e) {
    }
    textarea.value = before + text + after;
    try {
      document.execCommand("ms-endUndoUnit");
    } catch (e) {
    }
    textarea.dispatchEvent(new CustomEvent("input", { bubbles: true, cancelable: true }));
  }
  if (selectionStart != null && selectionEnd != null) {
    textarea.setSelectionRange(selectionStart, selectionEnd);
  } else {
    textarea.setSelectionRange(originalSelectionStart, textarea.selectionEnd);
  }
}
function styleSelectedText(textarea, styleArgs) {
  const text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
  let result;
  if (styleArgs.orderedList || styleArgs.unorderedList) {
    result = listStyle(textarea, styleArgs);
  } else if (styleArgs.multiline && isMultipleLines(text)) {
    result = multilineStyle(textarea, styleArgs);
  } else {
    result = blockStyle(textarea, styleArgs);
  }
  insertText(textarea, result);
}
function expandSelectionToLine(textarea) {
  const lines = textarea.value.split("\n");
  let counter = 0;
  for (let index = 0; index < lines.length; index++) {
    const lineLength = lines[index].length + 1;
    if (textarea.selectionStart >= counter && textarea.selectionStart < counter + lineLength) {
      textarea.selectionStart = counter;
    }
    if (textarea.selectionEnd >= counter && textarea.selectionEnd < counter + lineLength) {
      textarea.selectionEnd = counter + lineLength - 1;
    }
    counter += lineLength;
  }
}
function expandSelectedText(textarea, prefixToUse, suffixToUse, multiline = false) {
  if (textarea.selectionStart === textarea.selectionEnd) {
    textarea.selectionStart = wordSelectionStart(textarea.value, textarea.selectionStart);
    textarea.selectionEnd = wordSelectionEnd(textarea.value, textarea.selectionEnd, multiline);
  } else {
    const expandedSelectionStart = textarea.selectionStart - prefixToUse.length;
    const expandedSelectionEnd = textarea.selectionEnd + suffixToUse.length;
    const beginsWithPrefix = textarea.value.slice(expandedSelectionStart, textarea.selectionStart) === prefixToUse;
    const endsWithSuffix = textarea.value.slice(textarea.selectionEnd, expandedSelectionEnd) === suffixToUse;
    if (beginsWithPrefix && endsWithSuffix) {
      textarea.selectionStart = expandedSelectionStart;
      textarea.selectionEnd = expandedSelectionEnd;
    }
  }
  return textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
}
function newlinesToSurroundSelectedText(textarea) {
  const beforeSelection = textarea.value.slice(0, textarea.selectionStart);
  const afterSelection = textarea.value.slice(textarea.selectionEnd);
  const breaksBefore = beforeSelection.match(/\n*$/);
  const breaksAfter = afterSelection.match(/^\n*/);
  const newlinesBeforeSelection = breaksBefore ? breaksBefore[0].length : 0;
  const newlinesAfterSelection = breaksAfter ? breaksAfter[0].length : 0;
  let newlinesToAppend;
  let newlinesToPrepend;
  if (beforeSelection.match(/\S/) && newlinesBeforeSelection < 2) {
    newlinesToAppend = repeat("\n", 2 - newlinesBeforeSelection);
  }
  if (afterSelection.match(/\S/) && newlinesAfterSelection < 2) {
    newlinesToPrepend = repeat("\n", 2 - newlinesAfterSelection);
  }
  if (newlinesToAppend == null) {
    newlinesToAppend = "";
  }
  if (newlinesToPrepend == null) {
    newlinesToPrepend = "";
  }
  return { newlinesToAppend, newlinesToPrepend };
}
function blockStyle(textarea, arg) {
  let newlinesToAppend;
  let newlinesToPrepend;
  const { prefix, suffix, blockPrefix, blockSuffix, replaceNext, prefixSpace, scanFor, surroundWithNewlines } = arg;
  const originalSelectionStart = textarea.selectionStart;
  const originalSelectionEnd = textarea.selectionEnd;
  let selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
  let prefixToUse = isMultipleLines(selectedText) && blockPrefix.length > 0 ? `${blockPrefix}
` : prefix;
  let suffixToUse = isMultipleLines(selectedText) && blockSuffix.length > 0 ? `
${blockSuffix}` : suffix;
  if (prefixSpace) {
    const beforeSelection = textarea.value[textarea.selectionStart - 1];
    if (textarea.selectionStart !== 0 && beforeSelection != null && !beforeSelection.match(/\s/)) {
      prefixToUse = ` ${prefixToUse}`;
    }
  }
  selectedText = expandSelectedText(textarea, prefixToUse, suffixToUse, arg.multiline);
  let selectionStart = textarea.selectionStart;
  let selectionEnd = textarea.selectionEnd;
  const hasReplaceNext = replaceNext.length > 0 && suffixToUse.indexOf(replaceNext) > -1 && selectedText.length > 0;
  if (surroundWithNewlines) {
    const ref = newlinesToSurroundSelectedText(textarea);
    newlinesToAppend = ref.newlinesToAppend;
    newlinesToPrepend = ref.newlinesToPrepend;
    prefixToUse = newlinesToAppend + prefix;
    suffixToUse += newlinesToPrepend;
  }
  if (selectedText.startsWith(prefixToUse) && selectedText.endsWith(suffixToUse)) {
    const replacementText = selectedText.slice(prefixToUse.length, selectedText.length - suffixToUse.length);
    if (originalSelectionStart === originalSelectionEnd) {
      let position = originalSelectionStart - prefixToUse.length;
      position = Math.max(position, selectionStart);
      position = Math.min(position, selectionStart + replacementText.length);
      selectionStart = selectionEnd = position;
    } else {
      selectionEnd = selectionStart + replacementText.length;
    }
    return { text: replacementText, selectionStart, selectionEnd };
  } else if (!hasReplaceNext) {
    let replacementText = prefixToUse + selectedText + suffixToUse;
    selectionStart = originalSelectionStart + prefixToUse.length;
    selectionEnd = originalSelectionEnd + prefixToUse.length;
    const whitespaceEdges = selectedText.match(/^\s*|\s*$/g);
    if (arg.trimFirst && whitespaceEdges) {
      const leadingWhitespace = whitespaceEdges[0] || "";
      const trailingWhitespace = whitespaceEdges[1] || "";
      replacementText = leadingWhitespace + prefixToUse + selectedText.trim() + suffixToUse + trailingWhitespace;
      selectionStart += leadingWhitespace.length;
      selectionEnd -= trailingWhitespace.length;
    }
    return { text: replacementText, selectionStart, selectionEnd };
  } else if (scanFor.length > 0 && selectedText.match(scanFor)) {
    suffixToUse = suffixToUse.replace(replaceNext, selectedText);
    const replacementText = prefixToUse + suffixToUse;
    selectionStart = selectionEnd = selectionStart + prefixToUse.length;
    return { text: replacementText, selectionStart, selectionEnd };
  } else {
    const replacementText = prefixToUse + selectedText + suffixToUse;
    selectionStart = selectionStart + prefixToUse.length + selectedText.length + suffixToUse.indexOf(replaceNext);
    selectionEnd = selectionStart + replaceNext.length;
    return { text: replacementText, selectionStart, selectionEnd };
  }
}
function multilineStyle(textarea, arg) {
  const { prefix, suffix, surroundWithNewlines } = arg;
  let text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
  let selectionStart = textarea.selectionStart;
  let selectionEnd = textarea.selectionEnd;
  const lines = text.split("\n");
  const undoStyle = lines.every((line) => line.startsWith(prefix) && line.endsWith(suffix));
  if (undoStyle) {
    text = lines.map((line) => line.slice(prefix.length, line.length - suffix.length)).join("\n");
    selectionEnd = selectionStart + text.length;
  } else {
    text = lines.map((line) => prefix + line + suffix).join("\n");
    if (surroundWithNewlines) {
      const { newlinesToAppend, newlinesToPrepend } = newlinesToSurroundSelectedText(textarea);
      selectionStart += newlinesToAppend.length;
      selectionEnd = selectionStart + text.length;
      text = newlinesToAppend + text + newlinesToPrepend;
    }
  }
  return { text, selectionStart, selectionEnd };
}
function undoOrderedListStyle(text) {
  const lines = text.split("\n");
  const orderedListRegex = /^\d+\.\s+/;
  const shouldUndoOrderedList = lines.every((line) => orderedListRegex.test(line));
  let result = lines;
  if (shouldUndoOrderedList) {
    result = lines.map((line) => line.replace(orderedListRegex, ""));
  }
  return {
    text: result.join("\n"),
    processed: shouldUndoOrderedList
  };
}
function undoUnorderedListStyle(text) {
  const lines = text.split("\n");
  const unorderedListPrefix = "- ";
  const shouldUndoUnorderedList = lines.every((line) => line.startsWith(unorderedListPrefix));
  let result = lines;
  if (shouldUndoUnorderedList) {
    result = lines.map((line) => line.slice(unorderedListPrefix.length, line.length));
  }
  return {
    text: result.join("\n"),
    processed: shouldUndoUnorderedList
  };
}
function makePrefix(index, unorderedList) {
  if (unorderedList) {
    return "- ";
  } else {
    return `${index + 1}. `;
  }
}
function clearExistingListStyle(style, selectedText) {
  let undoResultOpositeList;
  let undoResult;
  let pristineText;
  if (style.orderedList) {
    undoResult = undoOrderedListStyle(selectedText);
    undoResultOpositeList = undoUnorderedListStyle(undoResult.text);
    pristineText = undoResultOpositeList.text;
  } else {
    undoResult = undoUnorderedListStyle(selectedText);
    undoResultOpositeList = undoOrderedListStyle(undoResult.text);
    pristineText = undoResultOpositeList.text;
  }
  return [undoResult, undoResultOpositeList, pristineText];
}
function listStyle(textarea, style) {
  const noInitialSelection = textarea.selectionStart === textarea.selectionEnd;
  let selectionStart = textarea.selectionStart;
  let selectionEnd = textarea.selectionEnd;
  expandSelectionToLine(textarea);
  const selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
  const [undoResult, undoResultOpositeList, pristineText] = clearExistingListStyle(style, selectedText);
  const prefixedLines = pristineText.split("\n").map((value, index) => {
    return `${makePrefix(index, style.unorderedList)}${value}`;
  });
  const totalPrefixLength = prefixedLines.reduce((previousValue, _currentValue, currentIndex) => {
    return previousValue + makePrefix(currentIndex, style.unorderedList).length;
  }, 0);
  const totalPrefixLengthOpositeList = prefixedLines.reduce((previousValue, _currentValue, currentIndex) => {
    return previousValue + makePrefix(currentIndex, !style.unorderedList).length;
  }, 0);
  if (undoResult.processed) {
    if (noInitialSelection) {
      selectionStart = Math.max(selectionStart - makePrefix(0, style.unorderedList).length, 0);
      selectionEnd = selectionStart;
    } else {
      selectionStart = textarea.selectionStart;
      selectionEnd = textarea.selectionEnd - totalPrefixLength;
    }
    return { text: pristineText, selectionStart, selectionEnd };
  }
  const { newlinesToAppend, newlinesToPrepend } = newlinesToSurroundSelectedText(textarea);
  const text = newlinesToAppend + prefixedLines.join("\n") + newlinesToPrepend;
  if (noInitialSelection) {
    selectionStart = Math.max(selectionStart + makePrefix(0, style.unorderedList).length + newlinesToAppend.length, 0);
    selectionEnd = selectionStart;
  } else {
    if (undoResultOpositeList.processed) {
      selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
      selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength - totalPrefixLengthOpositeList;
    } else {
      selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
      selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength;
    }
  }
  return { text, selectionStart, selectionEnd };
}
function applyStyle(button, stylesToApply) {
  const toolbar = button.closest("markdown-toolbar");
  if (!(toolbar instanceof MarkdownToolbarElement))
    return;
  const defaults = {
    prefix: "",
    suffix: "",
    blockPrefix: "",
    blockSuffix: "",
    multiline: false,
    replaceNext: "",
    prefixSpace: false,
    scanFor: "",
    surroundWithNewlines: false,
    orderedList: false,
    unorderedList: false,
    trimFirst: false
  };
  const style = Object.assign(Object.assign({}, defaults), stylesToApply);
  const field = toolbar.field;
  if (field) {
    field.focus();
    styleSelectedText(field, style);
  }
}
var __classPrivateFieldSet$1 = globalThis && globalThis.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet$1 = globalThis && globalThis.__classPrivateFieldGet || function(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DurationFormat_options;
class ListFormatPonyFill {
  formatToParts(members) {
    const parts = [];
    for (const value of members) {
      parts.push({ type: "element", value });
      parts.push({ type: "literal", value: ", " });
    }
    return parts.slice(0, -1);
  }
}
const ListFormat = typeof Intl !== "undefined" && Intl.ListFormat || ListFormatPonyFill;
const partsTable = [
  ["years", "year"],
  ["months", "month"],
  ["weeks", "week"],
  ["days", "day"],
  ["hours", "hour"],
  ["minutes", "minute"],
  ["seconds", "second"],
  ["milliseconds", "millisecond"]
];
const twoDigitFormatOptions = { minimumIntegerDigits: 2 };
class DurationFormat {
  constructor(locale, options = {}) {
    _DurationFormat_options.set(this, void 0);
    let style = String(options.style || "short");
    if (style !== "long" && style !== "short" && style !== "narrow" && style !== "digital")
      style = "short";
    let prevStyle = style === "digital" ? "numeric" : style;
    const hours = options.hours || prevStyle;
    prevStyle = hours === "2-digit" ? "numeric" : hours;
    const minutes = options.minutes || prevStyle;
    prevStyle = minutes === "2-digit" ? "numeric" : minutes;
    const seconds = options.seconds || prevStyle;
    prevStyle = seconds === "2-digit" ? "numeric" : seconds;
    const milliseconds = options.milliseconds || prevStyle;
    __classPrivateFieldSet$1(this, _DurationFormat_options, {
      locale,
      style,
      years: options.years || style === "digital" ? "short" : style,
      yearsDisplay: options.yearsDisplay === "always" ? "always" : "auto",
      months: options.months || style === "digital" ? "short" : style,
      monthsDisplay: options.monthsDisplay === "always" ? "always" : "auto",
      weeks: options.weeks || style === "digital" ? "short" : style,
      weeksDisplay: options.weeksDisplay === "always" ? "always" : "auto",
      days: options.days || style === "digital" ? "short" : style,
      daysDisplay: options.daysDisplay === "always" ? "always" : "auto",
      hours,
      hoursDisplay: options.hoursDisplay === "always" ? "always" : style === "digital" ? "always" : "auto",
      minutes,
      minutesDisplay: options.minutesDisplay === "always" ? "always" : style === "digital" ? "always" : "auto",
      seconds,
      secondsDisplay: options.secondsDisplay === "always" ? "always" : style === "digital" ? "always" : "auto",
      milliseconds,
      millisecondsDisplay: options.millisecondsDisplay === "always" ? "always" : "auto"
    }, "f");
  }
  resolvedOptions() {
    return __classPrivateFieldGet$1(this, _DurationFormat_options, "f");
  }
  formatToParts(duration) {
    const list = [];
    const options = __classPrivateFieldGet$1(this, _DurationFormat_options, "f");
    const style = options.style;
    const locale = options.locale;
    for (const [unit, nfUnit] of partsTable) {
      const value = duration[unit];
      if (options[`${unit}Display`] === "auto" && !value)
        continue;
      const unitStyle = options[unit];
      const nfOpts = unitStyle === "2-digit" ? twoDigitFormatOptions : unitStyle === "numeric" ? {} : { style: "unit", unit: nfUnit, unitDisplay: unitStyle };
      list.push(new Intl.NumberFormat(locale, nfOpts).format(value));
    }
    return new ListFormat(locale, {
      type: "unit",
      style: style === "digital" ? "short" : style
    }).formatToParts(list);
  }
  format(duration) {
    return this.formatToParts(duration).map((p) => p.value).join("");
  }
}
_DurationFormat_options = /* @__PURE__ */ new WeakMap();
const durationRe = /^[-+]?P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;
const unitNames = ["year", "month", "week", "day", "hour", "minute", "second", "millisecond"];
const isDuration = (str) => durationRe.test(str);
class Duration {
  constructor(years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    this.years = years;
    this.months = months;
    this.weeks = weeks;
    this.days = days;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
    this.milliseconds = milliseconds;
    this.years || (this.years = 0);
    this.sign || (this.sign = Math.sign(this.years));
    this.months || (this.months = 0);
    this.sign || (this.sign = Math.sign(this.months));
    this.weeks || (this.weeks = 0);
    this.sign || (this.sign = Math.sign(this.weeks));
    this.days || (this.days = 0);
    this.sign || (this.sign = Math.sign(this.days));
    this.hours || (this.hours = 0);
    this.sign || (this.sign = Math.sign(this.hours));
    this.minutes || (this.minutes = 0);
    this.sign || (this.sign = Math.sign(this.minutes));
    this.seconds || (this.seconds = 0);
    this.sign || (this.sign = Math.sign(this.seconds));
    this.milliseconds || (this.milliseconds = 0);
    this.sign || (this.sign = Math.sign(this.milliseconds));
    this.blank = this.sign === 0;
  }
  abs() {
    return new Duration(Math.abs(this.years), Math.abs(this.months), Math.abs(this.weeks), Math.abs(this.days), Math.abs(this.hours), Math.abs(this.minutes), Math.abs(this.seconds), Math.abs(this.milliseconds));
  }
  static from(durationLike) {
    var _a;
    if (typeof durationLike === "string") {
      const str = String(durationLike).trim();
      const factor = str.startsWith("-") ? -1 : 1;
      const parsed = (_a = str.match(durationRe)) === null || _a === void 0 ? void 0 : _a.slice(1).map((x) => (Number(x) || 0) * factor);
      if (!parsed)
        return new Duration();
      return new Duration(...parsed);
    } else if (typeof durationLike === "object") {
      const { years, months, weeks, days, hours, minutes, seconds, milliseconds } = durationLike;
      return new Duration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
    }
    throw new RangeError("invalid duration");
  }
  static compare(one, two) {
    const now = Date.now();
    const oneApplied = Math.abs(applyDuration(now, Duration.from(one)).getTime() - now);
    const twoApplied = Math.abs(applyDuration(now, Duration.from(two)).getTime() - now);
    return oneApplied > twoApplied ? -1 : oneApplied < twoApplied ? 1 : 0;
  }
  toLocaleString(locale, opts) {
    return new DurationFormat(locale, opts).format(this);
  }
}
function applyDuration(date, duration) {
  const r = new Date(date);
  r.setFullYear(r.getFullYear() + duration.years);
  r.setMonth(r.getMonth() + duration.months);
  r.setDate(r.getDate() + duration.weeks * 7 + duration.days);
  r.setHours(r.getHours() + duration.hours);
  r.setMinutes(r.getMinutes() + duration.minutes);
  r.setSeconds(r.getSeconds() + duration.seconds);
  return r;
}
function elapsedTime(date, precision = "second", now = Date.now()) {
  const delta = date.getTime() - now;
  if (delta === 0)
    return new Duration();
  const sign = Math.sign(delta);
  const ms = Math.abs(delta);
  const sec = Math.floor(ms / 1e3);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);
  const month = Math.floor(day / 30);
  const year = Math.floor(month / 12);
  const i = unitNames.indexOf(precision) || unitNames.length;
  return new Duration(i >= 0 ? year * sign : 0, i >= 1 ? (month - year * 12) * sign : 0, 0, i >= 3 ? (day - month * 30) * sign : 0, i >= 4 ? (hr - day * 24) * sign : 0, i >= 5 ? (min - hr * 60) * sign : 0, i >= 6 ? (sec - min * 60) * sign : 0, i >= 7 ? (ms - sec * 1e3) * sign : 0);
}
function roundToSingleUnit(duration, { relativeTo = Date.now() } = {}) {
  relativeTo = new Date(relativeTo);
  if (duration.blank)
    return duration;
  const sign = duration.sign;
  let years = Math.abs(duration.years);
  let months = Math.abs(duration.months);
  let weeks = Math.abs(duration.weeks);
  let days = Math.abs(duration.days);
  let hours = Math.abs(duration.hours);
  let minutes = Math.abs(duration.minutes);
  let seconds = Math.abs(duration.seconds);
  let milliseconds = Math.abs(duration.milliseconds);
  if (milliseconds >= 900)
    seconds += Math.round(milliseconds / 1e3);
  if (seconds || minutes || hours || days || weeks || months || years) {
    milliseconds = 0;
  }
  if (seconds >= 55)
    minutes += Math.round(seconds / 60);
  if (minutes || hours || days || weeks || months || years)
    seconds = 0;
  if (minutes >= 55)
    hours += Math.round(minutes / 60);
  if (hours || days || weeks || months || years)
    minutes = 0;
  if (days && hours >= 12)
    days += Math.round(hours / 24);
  if (!days && hours >= 21)
    days += Math.round(hours / 24);
  if (days || weeks || months || years)
    hours = 0;
  const currentYear = relativeTo.getFullYear();
  let currentMonth = relativeTo.getMonth();
  const currentDate = relativeTo.getDate();
  if (days >= 27 || years + months && days) {
    relativeTo.setDate(currentDate + days * sign);
    months += Math.abs(relativeTo.getFullYear() >= currentYear ? relativeTo.getMonth() - currentMonth : relativeTo.getMonth() - currentMonth - 12);
    if (months) {
      days = 0;
    }
    currentMonth = relativeTo.getMonth();
  }
  if (days >= 6)
    weeks += Math.round(days / 7);
  if (weeks || months || years)
    days = 0;
  if (weeks >= 4)
    months += Math.round(weeks / 4);
  if (months || years)
    weeks = 0;
  if (months >= 11 || years && months) {
    relativeTo.setMonth(relativeTo.getMonth() + months * sign);
    years += Math.abs(currentYear - relativeTo.getFullYear());
  }
  if (years)
    months = 0;
  return new Duration(years * sign, months * sign, weeks * sign, days * sign, hours * sign, minutes * sign, seconds * sign, milliseconds * sign);
}
function getRelativeTimeUnit(duration, opts) {
  const rounded = roundToSingleUnit(duration, opts);
  if (rounded.blank)
    return [0, "second"];
  for (const unit of unitNames) {
    if (unit === "millisecond")
      continue;
    const val = rounded[`${unit}s`];
    if (val)
      return [val, unit];
  }
  return [0, "second"];
}
var __classPrivateFieldGet = globalThis && globalThis.__classPrivateFieldGet || function(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = globalThis && globalThis.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _RelativeTimeElement_instances, _RelativeTimeElement_customTitle, _RelativeTimeElement_updating, _RelativeTimeElement_lang_get, _RelativeTimeElement_renderRoot, _RelativeTimeElement_getFormattedTitle, _RelativeTimeElement_resolveFormat, _RelativeTimeElement_getDurationFormat, _RelativeTimeElement_getRelativeFormat, _RelativeTimeElement_getDateTimeFormat, _RelativeTimeElement_onRelativeTimeUpdated;
const HTMLElement$1 = globalThis.HTMLElement || null;
const emptyDuration = new Duration();
const microEmptyDuration = new Duration(0, 0, 0, 0, 0, 1);
class RelativeTimeUpdatedEvent extends Event {
  constructor(oldText, newText, oldTitle, newTitle) {
    super("relative-time-updated", { bubbles: true, composed: true });
    this.oldText = oldText;
    this.newText = newText;
    this.oldTitle = oldTitle;
    this.newTitle = newTitle;
  }
}
function getUnitFactor(el) {
  if (!el.date)
    return Infinity;
  if (el.format === "duration" || el.format === "elapsed") {
    const precision = el.precision;
    if (precision === "second") {
      return 1e3;
    } else if (precision === "minute") {
      return 60 * 1e3;
    }
  }
  const ms = Math.abs(Date.now() - el.date.getTime());
  if (ms < 60 * 1e3)
    return 1e3;
  if (ms < 60 * 60 * 1e3)
    return 60 * 1e3;
  return 60 * 60 * 1e3;
}
const dateObserver = new class {
  constructor() {
    this.elements = /* @__PURE__ */ new Set();
    this.time = Infinity;
    this.timer = -1;
  }
  observe(element) {
    if (this.elements.has(element))
      return;
    this.elements.add(element);
    const date = element.date;
    if (date && date.getTime()) {
      const ms = getUnitFactor(element);
      const time = Date.now() + ms;
      if (time < this.time) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.update(), ms);
        this.time = time;
      }
    }
  }
  unobserve(element) {
    if (!this.elements.has(element))
      return;
    this.elements.delete(element);
  }
  update() {
    clearTimeout(this.timer);
    if (!this.elements.size)
      return;
    let nearestDistance = Infinity;
    for (const timeEl of this.elements) {
      nearestDistance = Math.min(nearestDistance, getUnitFactor(timeEl));
      timeEl.update();
    }
    this.time = Math.min(60 * 60 * 1e3, nearestDistance);
    this.timer = setTimeout(() => this.update(), this.time);
    this.time += Date.now();
  }
}();
class RelativeTimeElement extends HTMLElement$1 {
  constructor() {
    super(...arguments);
    _RelativeTimeElement_instances.add(this);
    _RelativeTimeElement_customTitle.set(this, false);
    _RelativeTimeElement_updating.set(this, false);
    _RelativeTimeElement_renderRoot.set(this, this.shadowRoot ? this.shadowRoot : this.attachShadow ? this.attachShadow({ mode: "open" }) : this);
    _RelativeTimeElement_onRelativeTimeUpdated.set(this, null);
  }
  static define(tag = "relative-time", registry = customElements) {
    registry.define(tag, this);
    return this;
  }
  static get observedAttributes() {
    return [
      "second",
      "minute",
      "hour",
      "weekday",
      "day",
      "month",
      "year",
      "time-zone-name",
      "prefix",
      "threshold",
      "tense",
      "precision",
      "format",
      "format-style",
      "datetime",
      "lang",
      "title"
    ];
  }
  get onRelativeTimeUpdated() {
    return __classPrivateFieldGet(this, _RelativeTimeElement_onRelativeTimeUpdated, "f");
  }
  set onRelativeTimeUpdated(listener) {
    if (__classPrivateFieldGet(this, _RelativeTimeElement_onRelativeTimeUpdated, "f")) {
      this.removeEventListener("relative-time-updated", __classPrivateFieldGet(this, _RelativeTimeElement_onRelativeTimeUpdated, "f"));
    }
    __classPrivateFieldSet(this, _RelativeTimeElement_onRelativeTimeUpdated, typeof listener === "object" || typeof listener === "function" ? listener : null, "f");
    if (typeof listener === "function") {
      this.addEventListener("relative-time-updated", listener);
    }
  }
  get second() {
    const second = this.getAttribute("second");
    if (second === "numeric" || second === "2-digit")
      return second;
  }
  set second(value) {
    this.setAttribute("second", value || "");
  }
  get minute() {
    const minute = this.getAttribute("minute");
    if (minute === "numeric" || minute === "2-digit")
      return minute;
  }
  set minute(value) {
    this.setAttribute("minute", value || "");
  }
  get hour() {
    const hour = this.getAttribute("hour");
    if (hour === "numeric" || hour === "2-digit")
      return hour;
  }
  set hour(value) {
    this.setAttribute("hour", value || "");
  }
  get weekday() {
    const weekday = this.getAttribute("weekday");
    if (weekday === "long" || weekday === "short" || weekday === "narrow") {
      return weekday;
    }
    if (this.format === "datetime" && weekday !== "")
      return this.formatStyle;
  }
  set weekday(value) {
    this.setAttribute("weekday", value || "");
  }
  get day() {
    var _a;
    const day = (_a = this.getAttribute("day")) !== null && _a !== void 0 ? _a : "numeric";
    if (day === "numeric" || day === "2-digit")
      return day;
  }
  set day(value) {
    this.setAttribute("day", value || "");
  }
  get month() {
    const format = this.format;
    let month = this.getAttribute("month");
    if (month === "")
      return;
    month !== null && month !== void 0 ? month : month = format === "datetime" ? this.formatStyle : "short";
    if (month === "numeric" || month === "2-digit" || month === "short" || month === "long" || month === "narrow") {
      return month;
    }
  }
  set month(value) {
    this.setAttribute("month", value || "");
  }
  get year() {
    var _a;
    const year = this.getAttribute("year");
    if (year === "numeric" || year === "2-digit")
      return year;
    if (!this.hasAttribute("year") && (/* @__PURE__ */ new Date()).getUTCFullYear() !== ((_a = this.date) === null || _a === void 0 ? void 0 : _a.getUTCFullYear())) {
      return "numeric";
    }
  }
  set year(value) {
    this.setAttribute("year", value || "");
  }
  get timeZoneName() {
    const name = this.getAttribute("time-zone-name");
    if (name === "long" || name === "short" || name === "shortOffset" || name === "longOffset" || name === "shortGeneric" || name === "longGeneric") {
      return name;
    }
  }
  set timeZoneName(value) {
    this.setAttribute("time-zone-name", value || "");
  }
  get prefix() {
    var _a;
    return (_a = this.getAttribute("prefix")) !== null && _a !== void 0 ? _a : this.format === "datetime" ? "" : "on";
  }
  set prefix(value) {
    this.setAttribute("prefix", value);
  }
  get threshold() {
    const threshold = this.getAttribute("threshold");
    return threshold && isDuration(threshold) ? threshold : "P30D";
  }
  set threshold(value) {
    this.setAttribute("threshold", value);
  }
  get tense() {
    const tense = this.getAttribute("tense");
    if (tense === "past")
      return "past";
    if (tense === "future")
      return "future";
    return "auto";
  }
  set tense(value) {
    this.setAttribute("tense", value);
  }
  get precision() {
    const precision = this.getAttribute("precision");
    if (unitNames.includes(precision))
      return precision;
    if (this.format === "micro")
      return "minute";
    return "second";
  }
  set precision(value) {
    this.setAttribute("precision", value);
  }
  get format() {
    const format = this.getAttribute("format");
    if (format === "datetime")
      return "datetime";
    if (format === "relative")
      return "relative";
    if (format === "duration")
      return "duration";
    if (format === "micro")
      return "micro";
    if (format === "elapsed")
      return "elapsed";
    return "auto";
  }
  set format(value) {
    this.setAttribute("format", value);
  }
  get formatStyle() {
    const formatStyle = this.getAttribute("format-style");
    if (formatStyle === "long")
      return "long";
    if (formatStyle === "short")
      return "short";
    if (formatStyle === "narrow")
      return "narrow";
    const format = this.format;
    if (format === "elapsed" || format === "micro")
      return "narrow";
    if (format === "datetime")
      return "short";
    return "long";
  }
  set formatStyle(value) {
    this.setAttribute("format-style", value);
  }
  get datetime() {
    return this.getAttribute("datetime") || "";
  }
  set datetime(value) {
    this.setAttribute("datetime", value);
  }
  get date() {
    const parsed = Date.parse(this.datetime);
    return Number.isNaN(parsed) ? null : new Date(parsed);
  }
  set date(value) {
    this.datetime = (value === null || value === void 0 ? void 0 : value.toISOString()) || "";
  }
  connectedCallback() {
    this.update();
  }
  disconnectedCallback() {
    dateObserver.unobserve(this);
  }
  attributeChangedCallback(attrName, oldValue, newValue) {
    if (oldValue === newValue)
      return;
    if (attrName === "title") {
      __classPrivateFieldSet(this, _RelativeTimeElement_customTitle, newValue !== null && (this.date && __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getFormattedTitle).call(this, this.date)) !== newValue, "f");
    }
    if (!__classPrivateFieldGet(this, _RelativeTimeElement_updating, "f") && !(attrName === "title" && __classPrivateFieldGet(this, _RelativeTimeElement_customTitle, "f"))) {
      __classPrivateFieldSet(this, _RelativeTimeElement_updating, (async () => {
        await Promise.resolve();
        this.update();
      })(), "f");
    }
  }
  update() {
    const oldText = __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent || this.textContent || "";
    const oldTitle = this.getAttribute("title") || "";
    let newTitle = oldTitle;
    const date = this.date;
    if (typeof Intl === "undefined" || !Intl.DateTimeFormat || !date) {
      __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent = oldText;
      return;
    }
    const now = Date.now();
    if (!__classPrivateFieldGet(this, _RelativeTimeElement_customTitle, "f")) {
      newTitle = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getFormattedTitle).call(this, date) || "";
      if (newTitle)
        this.setAttribute("title", newTitle);
    }
    const duration = elapsedTime(date, this.precision, now);
    const format = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_resolveFormat).call(this, duration);
    let newText = oldText;
    if (format === "duration") {
      newText = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getDurationFormat).call(this, duration);
    } else if (format === "relative") {
      newText = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getRelativeFormat).call(this, duration);
    } else {
      newText = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getDateTimeFormat).call(this, date);
    }
    if (newText) {
      __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent = newText;
    } else if (this.shadowRoot === __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f") && this.textContent) {
      __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent = this.textContent;
    }
    if (newText !== oldText || newTitle !== oldTitle) {
      this.dispatchEvent(new RelativeTimeUpdatedEvent(oldText, newText, oldTitle, newTitle));
    }
    if (format === "relative" || format === "duration") {
      dateObserver.observe(this);
    } else {
      dateObserver.unobserve(this);
    }
    __classPrivateFieldSet(this, _RelativeTimeElement_updating, false, "f");
  }
}
_RelativeTimeElement_customTitle = /* @__PURE__ */ new WeakMap(), _RelativeTimeElement_updating = /* @__PURE__ */ new WeakMap(), _RelativeTimeElement_renderRoot = /* @__PURE__ */ new WeakMap(), _RelativeTimeElement_onRelativeTimeUpdated = /* @__PURE__ */ new WeakMap(), _RelativeTimeElement_instances = /* @__PURE__ */ new WeakSet(), _RelativeTimeElement_lang_get = function _RelativeTimeElement_lang_get2() {
  var _a;
  return ((_a = this.closest("[lang]")) === null || _a === void 0 ? void 0 : _a.getAttribute("lang")) || this.ownerDocument.documentElement.getAttribute("lang") || "default";
}, _RelativeTimeElement_getFormattedTitle = function _RelativeTimeElement_getFormattedTitle2(date) {
  return new Intl.DateTimeFormat(__classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get), {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short"
  }).format(date);
}, _RelativeTimeElement_resolveFormat = function _RelativeTimeElement_resolveFormat2(duration) {
  const format = this.format;
  if (format === "datetime")
    return "datetime";
  if (format === "duration")
    return "duration";
  if (format === "elapsed")
    return "duration";
  if (format === "micro")
    return "duration";
  if ((format === "auto" || format === "relative") && typeof Intl !== "undefined" && Intl.RelativeTimeFormat) {
    const tense = this.tense;
    if (tense === "past" || tense === "future")
      return "relative";
    if (Duration.compare(duration, this.threshold) === 1)
      return "relative";
  }
  return "datetime";
}, _RelativeTimeElement_getDurationFormat = function _RelativeTimeElement_getDurationFormat2(duration) {
  const locale = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get);
  const format = this.format;
  const style = this.formatStyle;
  const tense = this.tense;
  let empty = emptyDuration;
  if (format === "micro") {
    duration = roundToSingleUnit(duration);
    empty = microEmptyDuration;
    if (this.tense === "past" && duration.sign !== -1 || this.tense === "future" && duration.sign !== 1) {
      duration = microEmptyDuration;
    }
  } else if (tense === "past" && duration.sign !== -1 || tense === "future" && duration.sign !== 1) {
    duration = empty;
  }
  const display = `${this.precision}sDisplay`;
  if (duration.blank) {
    return empty.toLocaleString(locale, { style, [display]: "always" });
  }
  return duration.abs().toLocaleString(locale, { style });
}, _RelativeTimeElement_getRelativeFormat = function _RelativeTimeElement_getRelativeFormat2(duration) {
  const relativeFormat = new Intl.RelativeTimeFormat(__classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get), {
    numeric: "auto",
    style: this.formatStyle
  });
  const tense = this.tense;
  if (tense === "future" && duration.sign !== 1)
    duration = emptyDuration;
  if (tense === "past" && duration.sign !== -1)
    duration = emptyDuration;
  const [int, unit] = getRelativeTimeUnit(duration);
  if (unit === "second" && int < 10) {
    return relativeFormat.format(0, "second");
  }
  return relativeFormat.format(int, unit);
}, _RelativeTimeElement_getDateTimeFormat = function _RelativeTimeElement_getDateTimeFormat2(date) {
  const formatter = new Intl.DateTimeFormat(__classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get), {
    second: this.second,
    minute: this.minute,
    hour: this.hour,
    weekday: this.weekday,
    day: this.day,
    month: this.month,
    year: this.year,
    timeZoneName: this.timeZoneName
  });
  return `${this.prefix} ${formatter.format(date)}`.trim();
};
const root = typeof globalThis !== "undefined" ? globalThis : window;
try {
  root.RelativeTimeElement = RelativeTimeElement.define();
} catch (e) {
  if (!(root.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) {
    throw e;
  }
}
const ctrlBindings = !!navigator.userAgent.match(/Macintosh/);
class Combobox {
  constructor(input, list) {
    this.input = input;
    this.list = list;
    this.isComposing = false;
    if (!list.id) {
      list.id = `combobox-${Math.random().toString().slice(2, 6)}`;
    }
    this.keyboardEventHandler = (event) => keyboardBindings(event, this);
    this.compositionEventHandler = (event) => trackComposition(event, this);
    this.inputHandler = this.clearSelection.bind(this);
    input.setAttribute("role", "combobox");
    input.setAttribute("aria-controls", list.id);
    input.setAttribute("aria-expanded", "false");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-haspopup", "listbox");
  }
  destroy() {
    this.clearSelection();
    this.stop();
    this.input.removeAttribute("role");
    this.input.removeAttribute("aria-controls");
    this.input.removeAttribute("aria-expanded");
    this.input.removeAttribute("aria-autocomplete");
    this.input.removeAttribute("aria-haspopup");
  }
  start() {
    this.input.setAttribute("aria-expanded", "true");
    this.input.addEventListener("compositionstart", this.compositionEventHandler);
    this.input.addEventListener("compositionend", this.compositionEventHandler);
    this.input.addEventListener("input", this.inputHandler);
    this.input.addEventListener("keydown", this.keyboardEventHandler);
    this.list.addEventListener("click", commitWithElement);
  }
  stop() {
    this.clearSelection();
    this.input.setAttribute("aria-expanded", "false");
    this.input.removeEventListener("compositionstart", this.compositionEventHandler);
    this.input.removeEventListener("compositionend", this.compositionEventHandler);
    this.input.removeEventListener("input", this.inputHandler);
    this.input.removeEventListener("keydown", this.keyboardEventHandler);
    this.list.removeEventListener("click", commitWithElement);
  }
  navigate(indexDiff = 1) {
    const focusEl = Array.from(this.list.querySelectorAll('[aria-selected="true"]')).filter(visible)[0];
    const els = Array.from(this.list.querySelectorAll('[role="option"]')).filter(visible);
    const focusIndex = els.indexOf(focusEl);
    if (focusIndex === els.length - 1 && indexDiff === 1 || focusIndex === 0 && indexDiff === -1) {
      this.clearSelection();
      this.input.focus();
      return;
    }
    let indexOfItem = indexDiff === 1 ? 0 : els.length - 1;
    if (focusEl && focusIndex >= 0) {
      const newIndex = focusIndex + indexDiff;
      if (newIndex >= 0 && newIndex < els.length)
        indexOfItem = newIndex;
    }
    const target = els[indexOfItem];
    if (!target)
      return;
    for (const el of els) {
      if (target === el) {
        this.input.setAttribute("aria-activedescendant", target.id);
        target.setAttribute("aria-selected", "true");
        scrollTo(this.list, target);
      } else {
        el.setAttribute("aria-selected", "false");
      }
    }
  }
  clearSelection() {
    this.input.removeAttribute("aria-activedescendant");
    for (const el of this.list.querySelectorAll('[aria-selected="true"]')) {
      el.setAttribute("aria-selected", "false");
    }
  }
}
function keyboardBindings(event, combobox) {
  if (event.shiftKey || event.metaKey || event.altKey)
    return;
  if (!ctrlBindings && event.ctrlKey)
    return;
  if (combobox.isComposing)
    return;
  switch (event.key) {
    case "Enter":
    case "Tab":
      if (commit(combobox.input, combobox.list)) {
        event.preventDefault();
      }
      break;
    case "Escape":
      combobox.clearSelection();
      break;
    case "ArrowDown":
      combobox.navigate(1);
      event.preventDefault();
      break;
    case "ArrowUp":
      combobox.navigate(-1);
      event.preventDefault();
      break;
    case "n":
      if (ctrlBindings && event.ctrlKey) {
        combobox.navigate(1);
        event.preventDefault();
      }
      break;
    case "p":
      if (ctrlBindings && event.ctrlKey) {
        combobox.navigate(-1);
        event.preventDefault();
      }
      break;
    default:
      if (event.ctrlKey)
        break;
      combobox.clearSelection();
  }
}
function commitWithElement(event) {
  if (!(event.target instanceof Element))
    return;
  const target = event.target.closest('[role="option"]');
  if (!target)
    return;
  if (target.getAttribute("aria-disabled") === "true")
    return;
  fireCommitEvent(target);
}
function commit(input, list) {
  const target = list.querySelector('[aria-selected="true"]');
  if (!target)
    return false;
  if (target.getAttribute("aria-disabled") === "true")
    return true;
  target.click();
  return true;
}
function fireCommitEvent(target) {
  target.dispatchEvent(new CustomEvent("combobox-commit", { bubbles: true }));
}
function visible(el) {
  return !el.hidden && !(el instanceof HTMLInputElement && el.type === "hidden") && (el.offsetWidth > 0 || el.offsetHeight > 0);
}
function trackComposition(event, combobox) {
  combobox.isComposing = event.type === "compositionstart";
  const list = document.getElementById(combobox.input.getAttribute("aria-controls") || "");
  if (!list)
    return;
  combobox.clearSelection();
}
function scrollTo(container, target) {
  if (!inViewport(container, target)) {
    container.scrollTop = target.offsetTop;
  }
}
function inViewport(container, element) {
  const scrollTop = container.scrollTop;
  const containerBottom = scrollTop + container.clientHeight;
  const top = element.offsetTop;
  const bottom = top + element.clientHeight;
  return top >= scrollTop && bottom <= containerBottom;
}
const boundary = /\s|\(|\[/;
function query(text, key, cursor, { multiWord, lookBackIndex, lastMatchPosition } = {
  multiWord: false,
  lookBackIndex: 0,
  lastMatchPosition: null
}) {
  let keyIndex = text.lastIndexOf(key, cursor - 1);
  if (keyIndex === -1)
    return;
  if (keyIndex < lookBackIndex)
    return;
  if (multiWord) {
    if (lastMatchPosition != null) {
      if (lastMatchPosition === keyIndex)
        return;
      keyIndex = lastMatchPosition - key.length;
    }
    const charAfterKey = text[keyIndex + 1];
    if (charAfterKey === " " && cursor >= keyIndex + key.length + 1)
      return;
    const newLineIndex = text.lastIndexOf("\n", cursor - 1);
    if (newLineIndex > keyIndex)
      return;
    const dotIndex = text.lastIndexOf(".", cursor - 1);
    if (dotIndex > keyIndex)
      return;
  } else {
    const spaceIndex = text.lastIndexOf(" ", cursor - 1);
    if (spaceIndex > keyIndex)
      return;
  }
  const pre = text[keyIndex - 1];
  if (pre && !boundary.test(pre))
    return;
  const queryString = text.substring(keyIndex + key.length, cursor);
  return {
    text: queryString,
    position: keyIndex + key.length
  };
}
const properties = ["position:absolute;", "overflow:auto;", "word-wrap:break-word;", "top:0px;", "left:-9999px;"];
const propertyNamesToCopy = [
  "box-sizing",
  "font-family",
  "font-size",
  "font-style",
  "font-variant",
  "font-weight",
  "height",
  "letter-spacing",
  "line-height",
  "max-height",
  "min-height",
  "padding-bottom",
  "padding-left",
  "padding-right",
  "padding-top",
  "border-bottom",
  "border-left",
  "border-right",
  "border-top",
  "text-decoration",
  "text-indent",
  "text-transform",
  "width",
  "word-spacing"
];
const mirrorMap = /* @__PURE__ */ new WeakMap();
function textFieldMirror(textField, markerPosition) {
  const nodeName = textField.nodeName.toLowerCase();
  if (nodeName !== "textarea" && nodeName !== "input") {
    throw new Error("expected textField to a textarea or input");
  }
  let mirror = mirrorMap.get(textField);
  if (mirror && mirror.parentElement === textField.parentElement) {
    mirror.innerHTML = "";
  } else {
    mirror = document.createElement("div");
    mirrorMap.set(textField, mirror);
    const style = window.getComputedStyle(textField);
    const props = properties.slice(0);
    if (nodeName === "textarea") {
      props.push("white-space:pre-wrap;");
    } else {
      props.push("white-space:nowrap;");
    }
    for (let i = 0, len = propertyNamesToCopy.length; i < len; i++) {
      const name = propertyNamesToCopy[i];
      props.push(`${name}:${style.getPropertyValue(name)};`);
    }
    mirror.style.cssText = props.join(" ");
  }
  const marker = document.createElement("span");
  marker.style.cssText = "position: absolute;";
  marker.innerHTML = "&nbsp;";
  let before;
  let after;
  if (typeof markerPosition === "number") {
    let text = textField.value.substring(0, markerPosition);
    if (text) {
      before = document.createTextNode(text);
    }
    text = textField.value.substring(markerPosition);
    if (text) {
      after = document.createTextNode(text);
    }
  } else {
    const text = textField.value;
    if (text) {
      before = document.createTextNode(text);
    }
  }
  if (before) {
    mirror.appendChild(before);
  }
  mirror.appendChild(marker);
  if (after) {
    mirror.appendChild(after);
  }
  if (!mirror.parentElement) {
    if (!textField.parentElement) {
      throw new Error("textField must have a parentElement to mirror");
    }
    textField.parentElement.insertBefore(mirror, textField);
  }
  mirror.scrollTop = textField.scrollTop;
  mirror.scrollLeft = textField.scrollLeft;
  return { mirror, marker };
}
function textFieldSelectionPosition(field, index = field.selectionEnd) {
  const { mirror, marker } = textFieldMirror(field, index);
  const mirrorRect = mirror.getBoundingClientRect();
  const markerRect = marker.getBoundingClientRect();
  setTimeout(() => {
    mirror.remove();
  }, 5e3);
  return {
    top: markerRect.top - mirrorRect.top,
    left: markerRect.left - mirrorRect.left
  };
}
const states = /* @__PURE__ */ new WeakMap();
class TextExpander {
  constructor(expander, input) {
    this.expander = expander;
    this.input = input;
    this.combobox = null;
    this.menu = null;
    this.match = null;
    this.justPasted = false;
    this.lookBackIndex = 0;
    this.oninput = this.onInput.bind(this);
    this.onpaste = this.onPaste.bind(this);
    this.onkeydown = this.onKeydown.bind(this);
    this.oncommit = this.onCommit.bind(this);
    this.onmousedown = this.onMousedown.bind(this);
    this.onblur = this.onBlur.bind(this);
    this.interactingWithList = false;
    input.addEventListener("paste", this.onpaste);
    input.addEventListener("input", this.oninput);
    input.addEventListener("keydown", this.onkeydown);
    input.addEventListener("blur", this.onblur);
  }
  destroy() {
    this.input.removeEventListener("paste", this.onpaste);
    this.input.removeEventListener("input", this.oninput);
    this.input.removeEventListener("keydown", this.onkeydown);
    this.input.removeEventListener("blur", this.onblur);
  }
  dismissMenu() {
    if (this.deactivate()) {
      this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex;
    }
  }
  activate(match, menu) {
    var _a, _b;
    if (this.input !== document.activeElement && this.input !== ((_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.activeElement)) {
      return;
    }
    this.deactivate();
    this.menu = menu;
    if (!menu.id)
      menu.id = `text-expander-${Math.floor(Math.random() * 1e5).toString()}`;
    this.expander.append(menu);
    this.combobox = new Combobox(this.input, menu);
    const { top, left } = textFieldSelectionPosition(this.input, match.position);
    menu.style.top = `${top}px`;
    menu.style.left = `${left}px`;
    this.combobox.start();
    menu.addEventListener("combobox-commit", this.oncommit);
    menu.addEventListener("mousedown", this.onmousedown);
    this.combobox.navigate(1);
  }
  deactivate() {
    const menu = this.menu;
    if (!menu || !this.combobox)
      return false;
    this.menu = null;
    menu.removeEventListener("combobox-commit", this.oncommit);
    menu.removeEventListener("mousedown", this.onmousedown);
    this.combobox.destroy();
    this.combobox = null;
    menu.remove();
    return true;
  }
  onCommit({ target }) {
    var _a;
    const item = target;
    if (!(item instanceof HTMLElement))
      return;
    if (!this.combobox)
      return;
    const match = this.match;
    if (!match)
      return;
    const beginning = this.input.value.substring(0, match.position - match.key.length);
    const remaining = this.input.value.substring(match.position + match.text.length);
    const detail = { item, key: match.key, value: null, continue: false };
    const canceled = !this.expander.dispatchEvent(new CustomEvent("text-expander-value", { cancelable: true, detail }));
    if (canceled)
      return;
    if (!detail.value)
      return;
    let suffix = (_a = this.expander.getAttribute("suffix")) !== null && _a !== void 0 ? _a : " ";
    if (detail.continue) {
      suffix = "";
    }
    const value = `${detail.value}${suffix}`;
    this.input.value = beginning + value + remaining;
    const cursor = beginning.length + value.length;
    this.deactivate();
    this.input.focus({
      preventScroll: true
    });
    this.input.selectionStart = cursor;
    this.input.selectionEnd = cursor;
    if (!detail.continue) {
      this.lookBackIndex = cursor;
      this.match = null;
    }
    this.expander.dispatchEvent(new CustomEvent("text-expander-committed", { cancelable: false, detail: { input: this.input } }));
  }
  onBlur() {
    if (this.interactingWithList) {
      this.interactingWithList = false;
      return;
    }
    this.deactivate();
  }
  onPaste() {
    this.justPasted = true;
  }
  async onInput() {
    if (this.justPasted) {
      this.justPasted = false;
      return;
    }
    const match = this.findMatch();
    if (match) {
      this.match = match;
      const menu = await this.notifyProviders(match);
      if (!this.match)
        return;
      if (menu) {
        this.activate(match, menu);
      } else {
        this.deactivate();
      }
    } else {
      this.match = null;
      this.deactivate();
    }
  }
  findMatch() {
    const cursor = this.input.selectionEnd || 0;
    const text = this.input.value;
    if (cursor <= this.lookBackIndex) {
      this.lookBackIndex = cursor - 1;
    }
    for (const { key, multiWord } of this.expander.keys) {
      const found = query(text, key, cursor, {
        multiWord,
        lookBackIndex: this.lookBackIndex,
        lastMatchPosition: this.match ? this.match.position : null
      });
      if (found) {
        return { text: found.text, key, position: found.position };
      }
    }
  }
  async notifyProviders(match) {
    const providers = [];
    const provide = (result) => providers.push(result);
    const canceled = !this.expander.dispatchEvent(new CustomEvent("text-expander-change", { cancelable: true, detail: { provide, text: match.text, key: match.key } }));
    if (canceled)
      return;
    const all = await Promise.all(providers);
    const fragments = all.filter((x) => x.matched).map((x) => x.fragment);
    return fragments[0];
  }
  onMousedown() {
    this.interactingWithList = true;
  }
  onKeydown(event) {
    if (event.key === "Escape") {
      this.match = null;
      if (this.deactivate()) {
        this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex;
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    }
  }
}
class TextExpanderElement extends HTMLElement {
  get keys() {
    const keysAttr = this.getAttribute("keys");
    const keys = keysAttr ? keysAttr.split(" ") : [];
    const multiWordAttr = this.getAttribute("multiword");
    const multiWord = multiWordAttr ? multiWordAttr.split(" ") : [];
    const globalMultiWord = multiWord.length === 0 && this.hasAttribute("multiword");
    return keys.map((key) => ({ key, multiWord: globalMultiWord || multiWord.includes(key) }));
  }
  connectedCallback() {
    const input = this.querySelector('input[type="text"], textarea');
    if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement))
      return;
    const state = new TextExpander(this, input);
    states.set(this, state);
  }
  disconnectedCallback() {
    const state = states.get(this);
    if (!state)
      return;
    state.destroy();
    states.delete(this);
  }
  dismiss() {
    const state = states.get(this);
    if (!state)
      return;
    state.dismissMenu();
  }
}
if (!window.customElements.get("text-expander")) {
  window.TextExpanderElement = TextExpanderElement;
  window.customElements.define("text-expander", TextExpanderElement);
}
const admin = "";
